"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Button: {
      margin: 0,
      boxSizing: 'border-box',
      cursor: 'pointer',
      verticalAlign: 'middle',
      lineHeight: 'initial',
      fontFamily: theme['$font-heading'],
      color: theme['$text-color'],
      fontWeight: 'bold',
      fontSize: 12,
      background: theme['$button-color'],
      padding: {
        top: 9,
        bottom: 9,
        left: 12,
        right: 14
      },
      border: 0,
      borderRadius: 6,
      boxShadow: {
        y: 1,
        blur: 1,
        color: theme['$shadow-color']
      },
      userSelect: 'none',
      outline: 'none',
      '&[disabled]': {
        opacity: 0.3,
        pointerEvents: 'none'
      },
      '&:hover, &:focus': {
        outline: 'none',
        boxShadow: {
          y: 3,
          blur: 6,
          color: theme['$shadow-color']
        }
      },
      '&:active, &.active': {
        background: theme['$button-color-active'],
        boxShadow: {
          y: 1,
          blur: 1,
          color: theme['$shadow-color']
        },
        '&.kind-lite': {
          fontFamily: theme['$font-default'],
          fontWeight: 'normal'
        },
        '&.kind-main': {
          background: theme['$button-primary-color-active']
        },
        '&.kind-secondary': {
          background: theme['$button-secondary-color-active']
        },
        '&.kind-negative': {
          background: theme['$button-negative-color-active']
        }
      },
      '&.kind-lite': {
        fontFamily: theme['$font-default'],
        fontWeight: 'normal'
      },
      '&.kind-main': {
        background: theme['$button-primary-color'],
        color: theme['$background-color']
      },
      '&.kind-secondary': {
        background: theme['$button-secondary-color'],
        color: theme['$background-color']
      },
      '&.kind-negative': {
        background: theme['$button-negative-color'],
        color: theme['$background-color']
      }
    },
    Error: {
      background: theme['$input-background-error']
    },
    Warning: {
      background: theme['$input-background-warning']
    },
    Disabled: {
      cursor: 'default',
      opacity: 0.3
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map